import React from "react";

import { IErrorContainerProps } from "./ErrorContainer.types";

const ErrorContainer: React.FC<IErrorContainerProps> = () => {
  return (
    <div>
      <p>not found</p>
    </div>
  );
};

export default ErrorContainer;
